/**
 * Constantes para patrones de rutas
 * Centraliza los patrones de idioma y rutas comunes para facilitar mantenimiento
 */

// Patrones de idioma
export const LANG_PATTERNS = {
  BILINGUAL: ':lang(en-en|es-es)',
  SOLUTIONS: ':lang(solutions|soluciones)',
  SERVICES: ':lang(services|servicios)',
  PRODUCTS: ':products(products|productos)',
  AWARDS: ':awards(awards|reconocimientos)',
  LANDINGS: ':lang(landings|landings)',
};

// Paths base comunes
export const BASE_PATHS = {
  // Rutas bilingües principales
  ABOUT: `/${LANG_PATTERNS.BILINGUAL}/about`,
  CAREERS: `/${LANG_PATTERNS.BILINGUAL}/careers`,
  CONTACT: `/${LANG_PATTERNS.BILINGUAL}/contact`,
  CULTURE: `/${LANG_PATTERNS.BILINGUAL}/culture`,

  // Servicios con secciones opcionales
  DEDICATED_TEAMS: `/${LANG_PATTERNS.BILINGUAL}/dedicate-teams-service`,
  DEVOPS_SRE: `/${LANG_PATTERNS.BILINGUAL}/devops-sre/:section?`,
  SOFTWARE_ENGINEERING: `/${LANG_PATTERNS.BILINGUAL}/software-engineering/:section?`,
  STAFF_AUGMENTATION: `/${LANG_PATTERNS.BILINGUAL}/staff-augmentation/:section?`,
  MICROSOFT_ECOSYSTEM: `/${LANG_PATTERNS.BILINGUAL}/microsoft-ecosystem/:section?`,
  ITAAS: `/${LANG_PATTERNS.BILINGUAL}/itaas/:section?`,

  // Productos
  PRODUCTS: `/${LANG_PATTERNS.BILINGUAL}/${LANG_PATTERNS.PRODUCTS}`,
  PRODUCTS_SECTION: `/${LANG_PATTERNS.BILINGUAL}/${LANG_PATTERNS.PRODUCTS}/:section`,

  // Políticas
  ORGANIZATIONAL_POLICY: `/${LANG_PATTERNS.BILINGUAL}/organizational-policy`,

  // Awards/Reconocimientos
  AWARDS: `/${LANG_PATTERNS.BILINGUAL}/${LANG_PATTERNS.AWARDS}`,

  // Simple Pay
  SIMPLE_PAY: `/${LANG_PATTERNS.BILINGUAL}/simple-pay`,

  // Landings comerciales
  COMERCIAL_DEVOPS: `/${LANG_PATTERNS.SERVICES}/devops-sre`,
  COMERCIAL_SOFTWARE_ENGINEERING: `/${LANG_PATTERNS.SERVICES}/software-engineering`,
  COMERCIAL_STAFF_AUGMENTATION: `/${LANG_PATTERNS.SERVICES}/staff-augmentation`,
  COMERCIAL_MICROSOFT: `/${LANG_PATTERNS.SERVICES}/microsoft-ecosystem`,
  COMERCIAL_ITAAS: `/${LANG_PATTERNS.SERVICES}/ITaaS`,

  // Soluciones dinámicas (NEW)s
  SOLUTIONS_INDEX: `/${LANG_PATTERNS.SOLUTIONS}`,
  // Adopción IA - ruta específica sin prefijo bilingüe
  SOLUTIONS_ADOPCION_IA: `/:lang(solutions|soluciones)/:slug(adopcion-ia|ai-adoption)`,
  SOLUTIONS_INTEGRATION_IA: `/:lang(solutions|soluciones)/:lang(ai-integration|integracion-ia)`,
  SOLUTIONS_AGENTS: `/:lang(solutions|soluciones)/:lang(agents|agentes)`,
  // Data - ruta estática específica
  SOLUTIONS_DATA: `/:lang(solutions|soluciones)/data`,
  // Security - ruta estática específica
  SOLUTIONS_SECURITY: `/:lang(solutions|soluciones)/:slug(security|seguridad)`,
  // Microsoft Ecosystem Landing - ruta estática específica
  MICROSOFT_ECOSYSTEM_LANDING: `/:lang(es|en)/microsoft-ecosystem`,

  SOLUTIONS_DETAIL: `/${LANG_PATTERNS.SOLUTIONS}/:slug`,

  // Landings POC genéricas
  LANDINGS_POC: `/${LANG_PATTERNS.LANDINGS}/:slug`,
  LANDINGS_COMERCIAL: `/${LANG_PATTERNS.LANDINGS}/programas-ia`,
  LANDINGS_COMERCIAL_BANCA: `/${LANG_PATTERNS.LANDINGS}/framework-IA-banca`,
  LANDINGS_COMERCIAL_GENERAL: `/${LANG_PATTERNS.LANDINGS}/framework-IA`,
  LANDINGS_COMERCIAL_OIL_GAS: `/${LANG_PATTERNS.LANDINGS}/framework-IA-oil-gas`,

  // Webinars
  WEBINAR_ITAAS: '/webinars/it-as-a-service',
  WEBINAR_PRODUCT_DISCOVERY: '/webinars/product-discovery',
  WEBINAR_MS_DYNAMICS: '/webinars/ms-dynamics-sales',
  WEBINAR_MS_DYNAMICS_ALT: '/webinars/microsoft-dynamics-sales',
  WEBINAR_VIVA_GOALS: '/webinars/viva-goals',
  WEBINAR_BDD: '/webinars/bdd',
  WEBINAR_SRE: '/webinars/sre',
  WEBINAR_PRODUCTIVIDAD: '/webinars/productividad-microsoft-365',

  // Páginas especiales
  HELPDESK: '/helpdesk',
  AI_SOFTWARE_SOLUTIONS: '/ai-software-solutions',
  NEARSHORE_US: '/nearshore-latam-us',
  NEARSHORE_ES: '/nearshore-latam-es',
  HOUSTON_REDIRECT: '/houston/:name?/:surname?',
};

// Google Analytics ID
export const GA_TRACKING_ID = 'UA-90867938-1';

